import ManageUserIdsModal from './ManageUserIdsModal';

export default ManageUserIdsModal;
